var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('PWAPrompt'),(_vm.isAuthenticated)?_c('AppBar'):_vm._e(),_c('v-main',{staticClass:"d-flex mt-5",class:{
      'align-center justify-center': !_vm.isAuthenticated,
    }},[_c('div',{staticClass:"mt-5 mr-5 ml-5"},[_c('router-view')],1)]),_c('v-snackbar',{attrs:{"bottom":"","right":"","value":_vm.updateExists,"timeout":-1,"color":"primary"}},[_vm._v(" An update is available "),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.refreshApp}},[_vm._v(" Update ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }